import { useContext } from "react";

import { BottomBarOverrideContext } from "../../context/sectionTabs/BottomBarOverrideContext";
import type { BottomBarOverrideContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: BottomBarOverrideContextValue = {
  bottomBarOverride: null,
  setBottomBarOverride: noop,
};

/**
 * Register/read a custom element that replaces the mobile shell's default
 * bottom nav.
 */
export const useMobileBottomBarOverride = () =>
  useContext(BottomBarOverrideContext) ?? FALLBACK_CONTEXT;
